


// src/auth/AuthContext.tsx
import React, { useEffect, useState } from "react";
import { login, fetchMe, logoutApi, type User, refreshToken } from "./auth";
import { setAccessToken } from "@/api/client";
import * as Sentry from "@sentry/react";
import { AuthContext, type AuthContextType } from "./context";
import {
  AUTH_SESSION_EXPIRED_EVENT,
  DEFAULT_SESSION_EXPIRED_MESSAGE,
} from "./sessionEvents";
import { useToastStore } from "@/ui/toastStore";
// import api from "../api/client";

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const pushToast = useToastStore((s) => s.push);

  useEffect(() => {
    if (user) {
      Sentry.setUser({
        id: String(user.id),
        username: user.username,
        email: user.email,
        is_superuser: user.is_superuser,
      });
    } else {
      Sentry.setUser(null);
    }
  }, [user]);

  // Boot-time: try refresh -> me
  useEffect(() => {
    const init = async () => {
      try {
        await refreshToken();

        const me = await fetchMe();
        setUser(me);
      } catch {
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    init();
  }, []);

  useEffect(() => {
    const handleSessionExpired = (event: Event) => {
      const detail =
        event instanceof CustomEvent && event.detail
          ? (event.detail as { message?: string })
          : undefined;
      const message = detail?.message || DEFAULT_SESSION_EXPIRED_MESSAGE;

      setAccessToken(null);
      setLoading(false);
      setUser((currentUser) => {
        if (currentUser) {
          pushToast(message, "warning");
        }
        return null;
      });
    };

    window.addEventListener(AUTH_SESSION_EXPIRED_EVENT, handleSessionExpired);
    return () => window.removeEventListener(AUTH_SESSION_EXPIRED_EVENT, handleSessionExpired);
  }, [pushToast]);

  const loginUser = async (username: string, password: string) => {
    try {
      await login(username, password);
      const me = await fetchMe();
      setUser(me);
      return true;
    } catch {
      return false;
    }
  };

  const logoutUser = async () => {
    try {
      await logoutApi();
    } finally {
      setUser(null);
      setAccessToken(null);
    }
  };

  const value: AuthContextType = {
    user,
    loading,
    loginUser,
    logoutUser,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};







// import { createContext, useContext, useEffect, useState } from "react";
// import api, { login, fetchMe, setAccessToken } from "../auth/auth";
// import axios from "axios";

// type User = {
//   id: number;
//   username: string;
//   is_superuser: boolean;
// };

// type AuthContextType = {
//   user: User | null;
//   loading: boolean;
//   loginUser: (u: string, p: string) => Promise<boolean>;
//   logoutUser: () => void;
// };

// const AuthContext = createContext<AuthContextType | null>(null);

// export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
//   const [user, setUser] = useState<User | null>(null);
//   const [loading, setLoading] = useState(true);

//   // Boot-time: try to refresh and load /me
//   useEffect(() => {
//     const init = async () => {
//       try {
//         const res = await axios.post("/api/token/refresh/", {}, { withCredentials: true });
//         const res2 = await api.post("/token/refresh/", {});
//         console.log(res2);
//         setAccessToken(res.data.access);
//         const me = await fetchMe();
//         setUser(me);
//       } catch {
//         setUser(null);
//       } finally {
//         setLoading(false);
//       }
//     };
//     init();
//   }, []);

//   const loginUser = async (username: string, password: string) => {
//     try {
//       await login(username, password);
//       const me = await fetchMe();
//       setUser(me);
//       return true;
//     } catch {
//       return false;
//     }
//   };

//   const logoutUser = () => {
//     setAccessToken(null);
//     setUser(null);
//   };

//   return (
//     <AuthContext.Provider value={{ user, loading, loginUser, logoutUser }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export const useAuth = () => {
//   const ctx = useContext(AuthContext);
//   if (!ctx) throw new Error("useAuth must be inside AuthProvider");
//   return ctx;
// };
